export const environment = {
  production: true,
  url: '',
  instance: 'v60test',
  userName: '',
  password: '',
};
